<div class="azm-toast" [class]="data.toastType" role="alert" aria-live="polite" [attr.aria-atomic]="true">
	<span class="azm-toast__icon-badge" aria-hidden="true">
		<azm-icon [name]="iconPreset().icon" [size]="18" [iconClass]="iconPreset().iconClass" [ariaHidden]="true" />
	</span>

	<div class="azm-toast__body">
		<p class="azm-toast__text">
			@if (toastTitle()) {
				<strong class="azm-toast__label">{{ toastTitle() | transloco }}</strong>
			}
			@if (toastMessage()) {
				<span class="azm-toast__message">{{ toastMessage() | transloco }}</span>
			}
		</p>
	</div>

	@if (data.config.closeButton) {
		<button
			type="button"
			class="azm-toast__close"
			[attr.aria-label]="'actions.close' | transloco"
			(click)="remove(); $event.stopPropagation()"
		>
			<azm-icon name="x" [size]="16" [ariaHidden]="true" />
		</button>
	}
</div>
